module.exports = __webpack_public_path__ + "static/img/coreTechnology_4.2b00475.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/coreTechnology_4.jpg
// module id = VJtg
// module chunks = 0